export default __webpack_public_path__ + "static/media/Scenery12.822c0bf5.jpg";